var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-subject-input" }, [
    _c(
      "label",
      {
        staticClass: "typographies-paragraph-medium-regular",
        class: _vm.classes,
        attrs: { for: "subject-input" }
      },
      [_vm._v("\n        " + _vm._s(_vm.$l10n.__("Objet")) + "\n    ")]
    ),
    _vm._v(" "),
    _c("input", {
      staticClass: "typographies-paragraph-medium-regular",
      attrs: { id: "subject-input", type: "text", maxlength: "250" },
      domProps: { value: _vm.subject },
      on: {
        input: function($event) {
          return _vm.$emit("update:subject", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }